// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductWrapper_wrapper__xLd_A","selected":"ProductWrapper_selected__ryIlZ","current":"ProductWrapper_current__ACy8B"};